import PhoneField from "@components/inputs/PhoneField";
import { Button, Dialog, TextField } from "kz-ui-sdk";
import React from "react";
import { useTranslation } from "react-i18next";
import { FcGoogle } from "react-icons/fc";
import { MdPerson } from "react-icons/md";

export interface PhoneAlreadyRegisteredDialogProps {
  open: boolean;
  onClose: () => void;
  onLogin: () => void;
  profile: {
    accessKey: string;
    phone: string;
    email?: string;
  };
  isLoading?: boolean;
}

const inputClasses = {
  "input&": "w-full !px-0 !ps-11 text-start",
  "input_disabled&": "!text-content-base !bg-transparent opacity-100",
  "iconContainer&": "!start-3 !top-[10px]",
};

const PhoneAlreadyRegisteredDialog = ({
  open,
  onClose,
  onLogin,
  profile: { accessKey, phone, email },
  isLoading,
}: PhoneAlreadyRegisteredDialogProps) => {
  const { t } = useTranslation();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onLogin();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t("phone already registered")}
      classes={{
        "container&": "relative z-[9999] max-h-[calc(100dvh-32px)] flex flex-col w-[calc(100%-32px)] max-w-[364px]",
        "title&": "font-bold text-xl leading-8 align-middle mb-0 text-content-base",
        "containerWrapper&": "!z-[10000]",
        "backDrop&": "!z-[9999]",
      }}
      transition
    >
      <form
        onSubmit={handleSubmit}
        className="flex flex-col gap-y-3"
      >
        <p className="text-center text-sm text-content-soft">{t("is this you click login")}</p>
        {accessKey && (
          <TextField
            value={accessKey}
            icon={<MdPerson className="text-2xl text-content-base" />}
            classes={inputClasses}
            size="sm"
            readOnly
            aria-label="Login username"
            data-element-id="input-phone-registered-username"
          />
        )}

        <PhoneField
          value={phone}
          readOnly
          classes={inputClasses}
          size="sm"
          aria-label="Login phone"
          data-element-id="input-registered-phone"
        />

        {email && (
          <TextField
            value={email}
            readOnly
            icon={<FcGoogle className="text-2xl text-content-base" />}
            classes={inputClasses}
            size="sm"
            aria-label="Login email"
            data-element-id="input-phone-registered-email"
          />
        )}

        <Button
          variant="primary"
          type="submit"
          loading={isLoading}
          disabled={isLoading}
          size="md"
          aria-label="Login submit username-password"
          className="mt-3"
          data-element-id="button-login-phone-registered"
        >
          {t("Login")}
        </Button>

        <Button
          onClick={onClose}
          aria-label="Register cancel"
          disabled={isLoading}
          type="button"
          size="md"
          variant="bordered"
          className="w-full !border-0 !bg-transparent"
          data-element-id="button-cancel-phone-registered"
        >
          {t("cancel")}
        </Button>
      </form>
    </Dialog>
  );
};

export default PhoneAlreadyRegisteredDialog;
